import { request } from "../../apis";

export const apiPostLogin = ({ params }) => request("post", `/user/login`, params, false);

export const apiPostRegister = ({ params }) => request("post", `/user/register`, params, false);

export const apiGetCaptcha = (params) => request("get", `/index/getCaptcha`, params, false);

export const apiGetLoginCs = (params) => request("get", `/index/login_kefu`, params, false);
